import { css, cx } from "@emotion/css"
import { useMemo } from "react"

type Props = {
  color: string
  base: number
  height: number
  direction: "top" | "bottom"
}

const Triangle = ({ color, base, height, direction }: Props) => {
  const style = useMemo(() => {
    const baseClassName = css`
      display: inline-block;
      border-right: ${base / 2}px solid transparent;
      border-left: ${base / 2}px solid transparent;
    `
    const directionClassName =
      direction === "top"
        ? css`
            border-bottom: ${height}px solid ${color};
          `
        : css`
            border-top: ${height}px solid ${color};
          `
    return cx(baseClassName, directionClassName)
  }, [base, color, direction, height])

  return <span className={style} />
}

export default Triangle
